module.exports = __webpack_public_path__ + "static/media/27.a841cf04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/27.svg
// module id = 145
// module chunks = 0